// ──────────────────────────────────────────────────────────────────────────
// /email-ingestion/config (Superadmin only)
// ──────────────────────────────────────────────────────────────────────────
export const EMAIL_SETTINGS_GET_CONFIG_REQUEST = 'EMAIL_SETTINGS_GET_CONFIG_REQUEST'
export const EMAIL_SETTINGS_GET_CONFIG_SUCCESS = 'EMAIL_SETTINGS_GET_CONFIG_SUCCESS'
export const EMAIL_SETTINGS_GET_CONFIG_FAIL = 'EMAIL_SETTINGS_GET_CONFIG_FAIL'
export const EMAIL_SETTINGS_GET_CONFIG_RESET = 'EMAIL_SETTINGS_GET_CONFIG_RESET'

export const EMAIL_SETTINGS_CREATE_CONFIG_REQUEST = 'EMAIL_SETTINGS_CREATE_CONFIG_REQUEST'
export const EMAIL_SETTINGS_CREATE_CONFIG_SUCCESS = 'EMAIL_SETTINGS_CREATE_CONFIG_SUCCESS'
export const EMAIL_SETTINGS_CREATE_CONFIG_FAIL = 'EMAIL_SETTINGS_CREATE_CONFIG_FAIL'
export const EMAIL_SETTINGS_CREATE_CONFIG_RESET = 'EMAIL_SETTINGS_CREATE_CONFIG_RESET'

export const EMAIL_SETTINGS_UPDATE_CONFIG_REQUEST = 'EMAIL_SETTINGS_UPDATE_CONFIG_REQUEST'
export const EMAIL_SETTINGS_UPDATE_CONFIG_SUCCESS = 'EMAIL_SETTINGS_UPDATE_CONFIG_SUCCESS'
export const EMAIL_SETTINGS_UPDATE_CONFIG_FAIL = 'EMAIL_SETTINGS_UPDATE_CONFIG_FAIL'
export const EMAIL_SETTINGS_UPDATE_CONFIG_RESET = 'EMAIL_SETTINGS_UPDATE_CONFIG_RESET'

// ──────────────────────────────────────────────────────────────────────────
// /email-ingestion/rules
// ──────────────────────────────────────────────────────────────────────────
export const EMAIL_SETTINGS_GET_RULES_REQUEST = 'EMAIL_SETTINGS_GET_RULES_REQUEST'
export const EMAIL_SETTINGS_GET_RULES_SUCCESS = 'EMAIL_SETTINGS_GET_RULES_SUCCESS'
export const EMAIL_SETTINGS_GET_RULES_FAIL = 'EMAIL_SETTINGS_GET_RULES_FAIL'
export const EMAIL_SETTINGS_GET_RULES_RESET = 'EMAIL_SETTINGS_GET_RULES_RESET'

export const EMAIL_SETTINGS_CREATE_RULES_REQUEST = 'EMAIL_SETTINGS_CREATE_RULES_REQUEST'
export const EMAIL_SETTINGS_CREATE_RULES_SUCCESS = 'EMAIL_SETTINGS_CREATE_RULES_SUCCESS'
export const EMAIL_SETTINGS_CREATE_RULES_FAIL = 'EMAIL_SETTINGS_CREATE_RULES_FAIL'
export const EMAIL_SETTINGS_CREATE_RULES_RESET = 'EMAIL_SETTINGS_CREATE_RULES_RESET'

export const EMAIL_SETTINGS_UPDATE_RULES_REQUEST = 'EMAIL_SETTINGS_UPDATE_RULES_REQUEST'
export const EMAIL_SETTINGS_UPDATE_RULES_SUCCESS = 'EMAIL_SETTINGS_UPDATE_RULES_SUCCESS'
export const EMAIL_SETTINGS_UPDATE_RULES_FAIL = 'EMAIL_SETTINGS_UPDATE_RULES_FAIL'
export const EMAIL_SETTINGS_UPDATE_RULES_RESET = 'EMAIL_SETTINGS_UPDATE_RULES_RESET'

export const EMAIL_SETTINGS_DELETE_RULE_REQUEST = 'EMAIL_SETTINGS_DELETE_RULE_REQUEST'
export const EMAIL_SETTINGS_DELETE_RULE_SUCCESS = 'EMAIL_SETTINGS_DELETE_RULE_SUCCESS'
export const EMAIL_SETTINGS_DELETE_RULE_FAIL = 'EMAIL_SETTINGS_DELETE_RULE_FAIL'
export const EMAIL_SETTINGS_DELETE_RULE_RESET = 'EMAIL_SETTINGS_DELETE_RULE_RESET'

// ──────────────────────────────────────────────────────────────────────────
// /email-ingestion/subscriptions
// ──────────────────────────────────────────────────────────────────────────
export const EMAIL_SETTINGS_GET_SUBSCRIPTIONS_REQUEST = 'EMAIL_SETTINGS_GET_SUBSCRIPTIONS_REQUEST'
export const EMAIL_SETTINGS_GET_SUBSCRIPTIONS_SUCCESS = 'EMAIL_SETTINGS_GET_SUBSCRIPTIONS_SUCCESS'
export const EMAIL_SETTINGS_GET_SUBSCRIPTIONS_FAIL = 'EMAIL_SETTINGS_GET_SUBSCRIPTIONS_FAIL'
export const EMAIL_SETTINGS_GET_SUBSCRIPTIONS_RESET = 'EMAIL_SETTINGS_GET_SUBSCRIPTIONS_RESET'

export const EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_REQUEST = 'EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_REQUEST'
export const EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_SUCCESS = 'EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_SUCCESS'
export const EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_FAIL = 'EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_FAIL'
export const EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_RESET = 'EMAIL_SETTINGS_CREATE_SUBSCRIPTIONS_RESET'

export const EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_REQUEST = 'EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_REQUEST'
export const EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_SUCCESS = 'EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_SUCCESS'
export const EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_FAIL = 'EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_FAIL'
export const EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_RESET = 'EMAIL_SETTINGS_UPDATE_SUBSCRIPTIONS_RESET'

// ──────────────────────────────────────────────────────────────────────────
// /email-ingestion/setup (combined bulk subscriptions + rules)
// ──────────────────────────────────────────────────────────────────────────
export const EMAIL_SETTINGS_SETUP_REQUEST = 'EMAIL_SETTINGS_SETUP_REQUEST'
export const EMAIL_SETTINGS_SETUP_SUCCESS = 'EMAIL_SETTINGS_SETUP_SUCCESS'
export const EMAIL_SETTINGS_SETUP_FAIL = 'EMAIL_SETTINGS_SETUP_FAIL'
export const EMAIL_SETTINGS_SETUP_RESET = 'EMAIL_SETTINGS_SETUP_RESET'

// ──────────────────────────────────────────────────────────────────────────
// Cached "is automated email processing on for the current user?" flag.
// Populated from /email-ingestion/subscriptions on first read and kept in sync
// by the settings panel as the user toggles or saves.
// ──────────────────────────────────────────────────────────────────────────
export const EMAIL_PROCESSING_STATUS_LOAD_REQUEST = 'EMAIL_PROCESSING_STATUS_LOAD_REQUEST'
export const EMAIL_PROCESSING_STATUS_SET = 'EMAIL_PROCESSING_STATUS_SET'
export const EMAIL_PROCESSING_STATUS_RESET = 'EMAIL_PROCESSING_STATUS_RESET'

// ──────────────────────────────────────────────────────────────────────────
// /GraphAPI?action=list_mail_folders (mailbox folder picker)
// ──────────────────────────────────────────────────────────────────────────
export const EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_REQUEST = 'EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_REQUEST'
export const EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_SUCCESS = 'EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_SUCCESS'
export const EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_FAIL = 'EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_FAIL'
export const EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_RESET = 'EMAIL_SETTINGS_GET_MAILBOX_FOLDERS_RESET'
